// reactstrap components
import { Container, Row } from "reactstrap";
// core components
import Header from "../../../components/Headers/Header.js";
import ErrorDataLog from "../../../components/ErrorDataLog.js";

const Errors = () => {
  return (
    <>
      <Header
        title="Survey Trouble Log"
        description="Survey Completion Description"
      />
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <ErrorDataLog />
          </div>
        </Row>
      </Container>
    </>
  );
};

export default Errors;
